






import { defineComponent, onActivated, onDeactivated, ref, Ref } from '@vue/composition-api';

export default defineComponent({
  name: 'Lax',
  setup(props, context) {
    // Refs
    const lax: Ref<HTMLDivElement | null> = ref(null);

    // TODO cleaner typescript integration (probably while migrating to Vue 3)
    // eslint-disable-next-line
    onActivated(() => (context.root as any).$lax.addElement(lax.value));
    // eslint-disable-next-line
    onDeactivated(() => (context.root as any).$lax.removeElement(lax.value));

    return {
      lax,
    };
  },
});
